/**
 * School-pasted-text natural-capture adapter.
 *
 * Thin contract wrapper around the shared school-text contract path.
 *
 * @param {import('./naturalCaptureContract').NaturalCaptureAdapterInput & { text?: string }} adapterInput
 * @param {Object} options
 * @param {Object} deps
 * @returns {import('./naturalCaptureContract').NaturalCaptureAdapterResult}
 */
export const runNaturalCaptureSchoolAdapter = (adapterInput = {}, {
  defaultDate = new Date(),
  childName = null,
  parserMode = 'school_text',
  sourceMode = 'school_text',
  inputMode = 'school_pasted_text',
  rawText = '',
} = {}, deps = {}) => {
  const text = String(adapterInput.text || '').trim();
  const canonicalRawText = String(rawText || text || '').trim();
  if (!text) {
    return {
      rows: [],
      debug: {
        parserUsed: null,
        parserMode,
        sourceMode,
        inputMode,
        adapterMode: 'school_pasted_text',
        inputType: 'unsupported',
        reason: 'empty_text',
        rawTextLength: 0,
      },
    };
  }

  const {
    buildNaturalCaptureSchoolRows,
    normalizeImportedSchoolReviewRows,
  } = deps || {};

  const schoolRows = typeof buildNaturalCaptureSchoolRows === 'function'
    ? buildNaturalCaptureSchoolRows(text, {
        defaultDate,
        childName,
      })
    : [];

  const rows = typeof normalizeImportedSchoolReviewRows === 'function'
    ? normalizeImportedSchoolReviewRows(schoolRows, {
        parserMode,
        sourceMode,
        inputMode,
        rawText: canonicalRawText || text,
      })
    : schoolRows;

  const categoryComparisons = [];
  const resolvedRows = rows;

  return {
    rows: resolvedRows,
    debug: {
      parserUsed: 'natural_capture_school_adapter',
      parserMode,
      sourceMode,
      inputMode,
      adapterMode: 'school_pasted_text',
      inputType: 'school_text',
      detectedShape: adapterInput.shapeHint || 'school_text',
      chunkPlanSource: 'buildSchoolEventChunks',
      reason: 'school_pasted_text',
      rawTextLength: canonicalRawText.length || text.length,
      rowCount: resolvedRows.length,
      categoryComparisons,
      decisionAudit: categoryComparisons.map((decision, index) => ({
        index,
        originalCategory: decision?.originalCategory || null,
        proposedCategory: decision?.proposedCategory || null,
        finalCategory: decision?.finalCategory || null,
        promotionApplied: Boolean(decision?.promotionApplied),
        promotionReason: decision?.promotionReason || '',
        adapterMode: inputMode,
        detectedShape: adapterInput.shapeHint || 'school_text',
        fallbackReason: decision?.reason?.[0] || '',
      })),
    },
  };
};
